import PropTypes from 'prop-types';

import { BaseBlockType } from './common.types';

export const QuestionAnswerBlockPropType = PropTypes.shape({
  ...BaseBlockType,
  questionGroup: PropTypes.number,
});
